import { BehaviorParameters } from 'rangeConfig/@types';
import { ProductType, RedOutlineComponent } from '@inter-ikea-storageone/range';
import { reportChangeTv } from 'analytics/reporters';
import {
  CollisionValidationResult,
  ComponentIds,
  Entity,
  MetaDataComponent,
  ProductComponent
} from '@inter-ikea-core/core';
import {
  setTvPlacement,
  setTvSize,
  showCollisionTVSheet
} from 'rangeConfig/shared/features/TVFeature/TVFeature';

const changeTV = ({ coreApi, dispatch, props }: BehaviorParameters) => {
  const coreProductId =
    props.tvPlacement === 'foot'
      ? 'tv_' + props.tvSize + '_black_foot'
      : 'tv_' + props.tvSize + '_black';

  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) return;
  const isTvSelected = coreApi.entities.isOneOfProductTypes(selectedEntity, [
    ProductType.TV,
    ProductType.TV_WITH_FOOT
  ]);

  const oldId = selectedEntity.getComponent<ProductComponent>(ComponentIds.PRODUCT_COMPONENT_ID)
    ?.productRef;

  const oldTvSize =
    selectedEntity.getComponent<MetaDataComponent>(ComponentIds.META_DATA_COMPONENT_ID)?.metaData
      .tvSize || 55;

  if (isTvSelected && oldId) {
    const placementResult = coreApi.products.removeAndAdd(selectedEntity.id, coreProductId);
    if (!placementResult) return;

    const { valid, errors, placedEntity } = placementResult;

    if (!valid && errors.length > 0) {
      const collisionResult =
        'collisions' in errors[0] ? (errors[0] as CollisionValidationResult) : null;
      if (collisionResult) {
        const collidingFrames = collisionResult.collisions
          .map(collision =>
            coreApi.entities.isProductType(collision.other, ProductType.BESTA_FRAME)
              ? collision.other
              : null
          )
          .filter(Boolean) as Entity[];
        collidingFrames.forEach(frame => frame.addComponent(new RedOutlineComponent()));
        dispatch(showCollisionTVSheet());
        coreApi.entities.disposeCollidingEntities(errors);
        coreApi.products.add(oldId, props.position);
      }
    } else if (placedEntity) {
      coreApi.entities.select(placedEntity);
      dispatch(setTvSize(props.tvSize));
      dispatch(setTvPlacement(props.tvPlacement));
      reportChangeTv({
        newTvSize: props.tvSize,
        oldTvSize: Number(oldTvSize),
        tvPlacement: props.tvPlacement
      });
    }
  }
};

export { changeTV };
